<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'projectsCrud'"
          crudName="Sistemas"
          newText="Novo Sistema"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
          :extra="extra"
          @view="view"
          @releases="releases"
          >>
        </base-crud>
      </div>
    </div>

    <jenkins-job-modal ref="jenkinsJobModal" @saved="refresh" />
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import JenkinsJobModal from "../../components/JenkinsJobModal";

export default {
  data: function () {
    return {
      table: "projectsTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: ["id", "name", "actions"],
      tableData: ["id", "name"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "name"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          name: "Nome",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        templates: {
          name: function (h, row, index) {
            const missing = !row.jenkins_job_front && !row.jenkins_job_api;
            return (
              <span>
                {row.name}
                {missing && (
                  <a
                    title="Sem job do Jenkins cadastrado — clique pra configurar"
                    style="cursor:pointer;color:#d29922;margin-left:6px;"
                    onClick={() =>
                      this.$parent.$parent.$parent.openJenkinsJobModal(row)
                    }
                  >
                    <i class="fas fa-exclamation-triangle"></i>
                  </a>
                )}
              </span>
            );
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },

      extra: [
        {
          id: 1,
          label: "",
          class: "btn btn-crud view",
          title: "Visualizar",
          name: "view",
          icon: "fas fa-eye",
        },
        {
          id: 2,
          label: "",
          class: "btn btn-crud view",
          title: "Releases",
          name: "releases",
          icon: "fas fa-code-branch",
        },
      ],
      endPoint: "projects/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
    JenkinsJobModal,
  },
  methods: {
    view(props, row, index) {
      const self = this;
      this.$router.push("/projects/view/" + props.row.id);
    },
    releases(props) {
      this.$router.push("/projects/" + props.row.id + "/releases");
    },
    openJenkinsJobModal(project) {
      this.$refs.jenkinsJobModal.open(project);
    },
    refresh() {
      this.$refs.projectsCrud.$refs.table.refresh();
    },
    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
      };

      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>
